import { notify } from '@carboncopyco/ui';
import copy from 'copy-to-clipboard';
import { useCallback, useState } from 'react';

export const useCopy = () => {
  const [isCopied, setIsCopied] = useState(false);
  const copyText = useCallback(
    (text: string, label?: string, onCopy?: () => void) => {
      const isCopied = copy(text, {
        message: '',
        format: 'text/plain',
      });

      setIsCopied(isCopied);
      if (isCopied) {
        onCopy?.();
        if (label) {
          notify.success(label);
        }
      }
    },
    []
  );

  return { copyText, isCopied };
};
